/*
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import './i18n/init';

import '@/utils/pluginKit';
import routes from '@/router';

function App() {
  const router = createBrowserRouter(routes, {
    basename: process.env.REACT_APP_BASE_URL,
  });
  const getCookie = (name: string) => {
    // 获取 cookie 字符串
    const value = `; ${document.cookie}`;
    const parts:any = value.split(`; ${name}=`);
    if (parts.length === 2) {
        // 返回指定名称的 cookie 值
        return parts.pop().split(';').shift();
    }
    return '';
}
  // const postLogin = () => { 
  //   const token:any = router.state.location.search.split('token=')[1];
  //   const ctoken = getCookie('token');
  //   if(token) {
  //     console.log(1111111, token)
  //     console.log(2222222, ctoken)
  //     console.log(333333333, ctoken === token);
  //     localStorage.setItem('_a_ltk_', token);
  //     // 删除浏览器地址栏中的token
  //     const url = window.location.href;
  //     const urlArr = url.split('?');
  //     const newUrl = urlArr[0];
  //     window.history.pushState({}, '0', newUrl);
  //   }
  // }
  // postLogin();
  if(getCookie('token')) {
    localStorage.setItem('_a_ltk_', getCookie('token'));
  }
  return (
    <>
    <RouterProvider router={router} />;
    </>

  )
}

export default App;
